import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  ._font-14 {
    font-size: 0.875rem;
  }

  body {
    color: var(--gray-900) !important;
    overflow-y: auto !important;
  }
`

export default GlobalStyle
